import React from 'react'
import { useProfile } from 'hooks/useProfile'
import Calm from 'assets/images/onboarding/Calm.svg'
import IdeaLady from 'assets/images/onboarding/IdeaLady.svg'
import FlowersImage from 'assets/images/onboarding/WateringFlowers.svg'
import PhoneExploding from 'assets/images/onboarding/PhoneExploding.svg'

import './style.scss'

const Benefit = ({ benefit }) => {
    return (
        <div className=" benefitCard">
            {benefit.image}
            {benefit.text}
        </div>
    )
}
const Benefits = () => {
    const { pilotTag } = useProfile()

    const benefits = [
        {
            id: 0,
            image: <img src={Calm} alt="calm" />,
            text: pilotTag?.toLowerCase().includes('accenture') ? (
                <p>
                    Access <span>Accenture benefits</span> such as Fiit, Calm and more{' '}
                </p>
            ) : (
                <p>
                    Access all your <span>benefits</span> in one place.
                </p>
            ),
        },
        {
            id: 1,
            image: <img src={PhoneExploding} alt="PhoneExploding" />,
            text: (
                <p>
                    Explore <span>100s of resources</span> vetted by wellbeing experts
                </p>
            ),
        },
        {
            id: 2,
            image: <img src={IdeaLady} alt="IdeaLady" />,
            text: (
                <p>
                    Discover <span>personalised resources</span> based on your needs
                </p>
            ),
        },
        {
            id: 3,
            image: <img src={FlowersImage} alt="FlowersImage" />,
            text: (
                <p>
                    Develop <span>good wellbeing</span> habits through tools and content
                </p>
            ),
        },
    ]

    return (
        <div className="benefitCardRow">
            {benefits.map(benefit => (
                <Benefit benefit={benefit} key={benefit.id} />
            ))}
        </div>
    )
}

export default Benefits
